import { createFileRoute } from '@tanstack/react-router'
import { UsuariosScreen } from '@web/app/features/usuarios/screens'
import { UserCog } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/security/users')({
  component: UsuariosScreen,
  staticData: {
      metaRoute: {
        title: 'Usuarios',
        order: 1,
        icon: UserCog,
      },
    },
})

